import { keepPreviousData, useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import {
  SurveyCommunicationType,
  SurveyStatus,
  SurveyTriggerTime,
  SurveyTriggerType,
  SurveyType,
} from '@/models'
import { resetQueries } from '@/utils'

export interface GetSurveysRequest {
  buildingId: number | undefined
  fromDate?: number
  limit?: number
  query?: string
  skip?: number
  status?: SurveyStatus
  toDate?: number
}

export interface SurveyHistoryItem {
  communicationType: SurveyCommunicationType
  endDate: number | null
  id: number
  isEventSurvey: boolean
  isOneTime: boolean
  name: string
  startDate: number
  startTime: number | null
  startTriggerDays?: number
  startTriggerTime?: SurveyTriggerTime
  startTriggerType?: SurveyTriggerType
  status: SurveyStatus
  subtype: string | null
  type: SurveyType
}

export interface GetSurveysResponse {
  count: number
  countCompleted: number
  countOnHold: number
  countOngoing: number
  countScheduled: number
  surveys: SurveyHistoryItem[]
}

export const USE_GET_SURVEYS_QUERY_KEY = 'useGetSurveys'

export const getSurveysQueryKey = (data: GetSurveysRequest) => [USE_GET_SURVEYS_QUERY_KEY, data]

export const getSurveys = async (data: GetSurveysRequest) => {
  const response = await authAPI.get<GetSurveysResponse>('/survey/dashboard/', { params: data })
  return response.data
}

export const useGetSurveys = (data: GetSurveysRequest) => {
  return useQuery({
    enabled: !!data.buildingId,
    placeholderData: keepPreviousData,
    queryFn: () => getSurveys(data),
    queryKey: getSurveysQueryKey(data),
  })
}

export const useInvalidateSurveys = () => {
  return () => resetQueries([USE_GET_SURVEYS_QUERY_KEY])
}
